import { StyleSheet } from 'react-native';
import { Device } from 'DeviceUtils';
import Theme from 'Theme';

const defaultStyles = {
    container: {
        flex: 1,
        position: 'relative',
        overflow: 'visible',
        paddingBottom: Theme.primaryPaddingBottom,
        paddingHorizontal: Theme.primaryMargin,
        height: '100%',
        width: '100%'
    },
    text: {
        fontFamily: Theme.regularFont,
        fontSize: Theme.primaryFontSize,
        marginHorizontal: 20,
        color: Theme.primaryTextColor,
        justifyContent: 'center',
        alignItems: 'center'
    },
    header: {
        backgroundColor: Theme.primaryBackgroundColor,
        alignSelf: 'stretch',
        paddingVertical: 10,
        paddingHorizontal: 20
    },
    carousel: {
        marginTop: 10,
        marginEnd: -Theme.primaryMargin,
        marginRight: -Theme.primaryMargin
    },
    seriesCarousel: {
        marginTop: -10,
        marginEnd: -Theme.primaryMargin,
        marginRight: -Theme.primaryMargin
    },
    noResultsTextContainer: {
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1
    },
    noResultsText: {
        color: Theme.secondaryTextColor
    },
    activityIndicator: {
        position: 'absolute'
        // marginTop: 40
    },
    activityIndicatorContainer: {
        position: 'absolute',
        width: '100%',
        height: '100%'
    }
};

if (Device.isWeb) {
    defaultStyles.carousel.marginEnd = 0;
    defaultStyles.carousel.marginRight = 0;
}

export default StyleSheet.create(defaultStyles);
